import classNames from "classnames";
import { useActivityParent } from "PFApp/activities/show/hooks/use_activity_parent";
import { useTemplate } from "PFApp/hooks";
import { Activity, Shortlist } from "PFCore/types";

import { useActivityCurrentUserRole, useActivityTemplateType } from "../../../activities/hooks";
import AcceptedButtons from "./buttons/accepted_buttons";
import BookedOrConfirmedButtons from "./buttons/booked_or_confirmed_buttons";
import DeclinedButtons from "./buttons/declined_buttons";
import FillRoleButton from "./buttons/pending_buttons";
import RespondedTag from "./buttons/responded_tag";
import css from "./buttons/shortlist_item_buttons.module.scss";

type AuditShortlistItemButtonsProps = {
  role: Activity;
  shortlistedProfile: Shortlist;
  isUnbiasedMode?: boolean;
};

export const AuditShortlistItemButtons = ({
  role,
  shortlistedProfile,
  isUnbiasedMode
}: AuditShortlistItemButtonsProps) => {
  const { isAudit } = useActivityTemplateType(role);

  const parentActivity = useActivityParent(role);
  const template = useTemplate(role.template_id);
  const isRole = template?.key.includes("role");
  const qaPrefix = "shortlist";
  const isDeclined = shortlistedProfile.state === "declined";
  const { isReviewer, isResourcer } = useActivityCurrentUserRole(role);
  const hasException = role.workflow_state === "exception";

  const buttonsProps = {
    item: shortlistedProfile,
    activity: role,
    parentActivity,
    isAudit,
    isResourcer,
    isReviewer,
    isRole,
    qaPrefix,
    hasException,
    isUnbiasedMode,
    template
  };

  const Buttons = {
    pending: FillRoleButton,
    accepted: AcceptedButtons,
    declined: DeclinedButtons,
    assigned: AcceptedButtons,
    filled: RespondedTag,
    rejected: FillRoleButton,
    booked: BookedOrConfirmedButtons,
    confirmed: BookedOrConfirmedButtons
  }[shortlistedProfile.state];

  return (
    <div className={classNames(css.actionButtons, { [css.declinedState]: isDeclined })}>
      <Buttons {...buttonsProps} />
    </div>
  );
};
